@if (product) {
  @if (viewMode$ | async; as viewMode) {
    <div>
      <div class="TabBody">
        <div class="cx-sorting top pdp-tab-heading-blue">
          <div class="sorting-block">
            <div class="top-section-ui row">
              <div class="col-12 col-sm-12 col-md-12 col-lg-6"></div>
              <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                <div class="row justify-content-end">
                  <div class="pdp-sorting col-8 col-sm-8 col-md-10 col-lg-8">
                    <label for="pdp-select-part">{{"common.sort_by_pdp" | cxTranslate}}</label>
                    <div class="select-box">
                      <select id="pdp-select-part" name="sort"
                        class="form-control pdp-select pdp-part-sort" [formControl]="sortControl"
                        (change)="sortControlValueChanged($event,productCopy)">
                        <option value='description_asc' [selected]="true">{{"common.text_pdp_document_desc_asc" |
                        cxTranslate}}</option>
                        <option value='description_desc'>{{"common.text_pdp_document_desc_desc" |
                        cxTranslate}}</option>
                        <option value='docType_asc'>{{"common.text_pdp_document_type_asc" |
                        cxTranslate}}</option>
                        <option value='docType_desc'>{{"common.text_pdp_document_type_desc" |
                        cxTranslate}}</option>
                        <option value='code_asc'>{{"common.text_pdp_document_code_asc" | cxTranslate}}
                        </option>
                        <option value='code_desc'> {{"common.text_pdp_document_code_desc" |
                        cxTranslate}}</option>
                        <option value='releaseDate_asc'>{{"common.text_pdp_document_relDate_asc" |
                        cxTranslate}}</option>
                        <option value='releaseDate_desc'>{{"common.text_pdp_document_relDate_desc" |
                        cxTranslate}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="pdp-search col-1 col-sm-1 col-md-1 col-lg-1">
                    <a (click)="showSearch = !showSearch">
                      <img src="/icons/search-icon-white.svg" alt=""
                        class="search-icon" width="20" height="20" />
                      </a>
                    </div>
                    <div
                      class="no-padding mode-change d-sm-none d-lg-flex product-view-btn col-1 col-md-1 col-lg-1">
                      <cx-product-view (modeChange)="setViewMode($event)"
                      [mode]="viewMode"></cx-product-view>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                @if (showSearch) {
                  <div class="top-section-ui col-12 col-sm-12 justify-content-end">
                    <div class="Searchbox col-10 col-sm-10 col-lg-10">
                      <input type="text" id="inputValue" class="form-control DocumentSearch"
                        [formControl]="inputFormControl"
                        placeholder="{{'common.text_pdp_document_search' | cxTranslate}}"
                        (keyup)="InputValueChanged($event,productCopy)">
                        <div class="pdp-PDPSearchBox">
                          <img src="/icons/search-icon-white.svg" alt="" class="search-icon"
                            width="20" height="20" />
                          </div>
                        </div>
                        <div class="Searchbox pdp-close-icon  col-1 col-sm-1 col-lg-1">
                          <a (click)="showSearch = !showSearch">
                            <img src="/icons/close_white.svg" alt=""
                              class="close-icon pdp-close-img" width="20" height="20" />
                            </a>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <div id="product-results-list" class="cx-product-container pdp-tab-innerblock-toggle">
                  @if (viewMode === ViewModes.Grid || isMobile) {
                    <div class="row">
                      @for (product of productCopy; track product) {
                        <app-kb-document-grid [product]="product"
                        class="col-12 col-sm-12 col-md-12 col-lg-3"></app-kb-document-grid>
                      }
                    </div>
                  }
                  @if (viewMode === ViewModes.List && !isMobile) {
                    @for (product of productCopy; track product) {
                      <app-kb-document-list [product]="product"
                      class="col-12 col-sm-6 col-md-3 pdp-docListTab"></app-kb-document-list>
                    }
                  }
                </div>
              </div>
            </div>
          }
        }
